const state = {
    routerModel:'',
}
const mutations = {
    setRouterModel(state, model) {
        state.routerModel = model
    },
}
const actions = {

}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
